import axiosInstance from '../axiosInterceptor/axiosInstance'

const activateSubscription = async (data) => {
  const url = `v1/orgs/${data.orgId}/billing/activate`
  return axiosInstance.post(url)
}

export default activateSubscription
